import { useCallback, useEffect, useRef } from "react";
import { Notification, UserAccount } from "../data/types";
import SignalRServiceManager from "./SignalRServiceManager";

type NotificationSignalRProps = {
    primaryAccount?: UserAccount;
    onUpsertNotification?: (notification: Notification[]) => void;
}
export const useNotificationSignalR = (props: NotificationSignalRProps) => {
    const { primaryAccount, onUpsertNotification } = props;
    const messageName = "upsertNotification";

    // Use useRef to maintain stable reference
    const onUpsertNotificationRef = useRef(onUpsertNotification);
    useEffect(() => {
        onUpsertNotificationRef.current = onUpsertNotification;
    }, [onUpsertNotification]);

    const upsertHandler = useCallback((objJson: string) => {
        try {
            const theObj = JSON.parse(objJson);
            onUpsertNotificationRef.current?.(theObj);
        } catch (error) {
            console.error("Failed to parse signalR message:", error, objJson);
        }
    }, []); // Now stable

    useEffect(() => {
        let signalRManager: Awaited<ReturnType<typeof SignalRServiceManager.getInstance>> | null = null;

        const setupSignalR = async () => {
            if (primaryAccount) {
                signalRManager = await SignalRServiceManager.getInstance(primaryAccount);
                signalRManager?.on(messageName, upsertHandler);
            }
        };

        setupSignalR();

        return () => {
            signalRManager?.off(messageName, upsertHandler);
        };
    }, [primaryAccount, upsertHandler]);

    return null;
}